import { HandymanJobPage } from '@/index/service-category/handyman/HandymanJobPage'
import { PageAnalytics } from '@/commons/PageAnalytics'
import { getJobPageStaticProps } from 'utils/handyman-job-page-props'

// Copy lives in data/handyman-job-pages.js under 'power-trip-repair'.
export const getStaticProps = () => getJobPageStaticProps('power-trip-repair')

export default function Page(props) {
  return (
    <>
      <HandymanJobPage {...props} />
      <PageAnalytics />
    </>
  )
}
